import { bl_fi_stmt_account_event_customer_category_filter_RowClass } from '../../../dbschema/bl_fi_stmt_account_event_customer_category_filter.model';
import { BaseContainerModel } from '../../base-container.model';

export class StatementOfAccountEventCustomerCategoryFilterModel extends BaseContainerModel {
  bl_fi_stmt_account_event_customer_category_filter: bl_fi_stmt_account_event_customer_category_filter_RowClass = new bl_fi_stmt_account_event_customer_category_filter_RowClass();
}